<h1>Step on Omelet Egg</h1>
<p>1.Get 2 or more Eggs.</p>
<img src="images/Step1.jpg" alt="">
<p>2.Crack Eggs into a Bowl First.</p>
<img src="images/OmeletStep2.jpg" alt="">
<img src="images/StirEgg.gif" alt="EGGGGGGGGG">
<p>3.Get any Soy/Fish Sauce.</p>

<p>4.Mix your Soy/Fish Sauce into the Bowl.</p>
<img src="images/OmeletStep4.gif" alt="">
<p>5.Add any Toppings you want.</p>
<img src="images/OmeletStep5.gif" alt="">
<p>6.Put and Heat the cooking Oil in an Iron Pan.</p>
<img src="images/OmeletStep6.gif" alt="">
<p>7.Set over Medium to High heat until slightly smoking.</p>
<p>8.Hold the Egg Bowl one Foot above the Pan and pour the Egg Mixture into the Oil in one go!</p>
<img src="images/OmeletStep8.gif" alt="">
<p>9.The Omelet will IMMEDIATELY Puff up, after 20 Seconds, Flip the Omelet.</p>
<img src="images/OmeletStep9.gif" alt="">
<p>10.Let the other side cook for another 20 seconds.</p>
<p>11.Serve it NOW!</p>
<img src="images/OmeletStep11.gif" alt="">
<br>
<br>
